import HomePageDocumentContentAPICall from "src/service/HomePageDocumentContentAPICall";
import BaseRepository from "./BaseRepository";

class HomePageDocumentContentRepository extends BaseRepository {
    getDocumentList = async (search, page, limit, orderByDirection = "asc", orderBy = "DocumentType", selectedFilterList = [], dateRangeObject = []) => {
        return await new HomePageDocumentContentAPICall().getDocumentList(search, page, limit, orderByDirection, orderBy, selectedFilterList, dateRangeObject)
    };
}

export default HomePageDocumentContentRepository;